<template>
	<div>
		<el-form :inline="true">
			<!-- <el-form-item label="创建时间" label-width="100">
        <el-date-picker
          v-model="searchForm.createTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy年MM月dd日"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item> -->
			<!-- <el-form-item label="名称" label-width="100">
        <el-input
          v-model="searchForm.couponsName"
          placeholder="名称"
          @clear="current = 1"
          clearable
        ></el-input>
      </el-form-item> -->

			<!-- <el-form-item label="优惠规则类型" label-width="100">
				<el-select v-model="searchForm.type" clearable placeholder="选择优惠规则类型" @clear="current = 1">
					<el-option label="无门槛" value="1"></el-option>
					<el-option label="满减" value="2"></el-option>
					<el-option label="批量赠送" value="3"></el-option>
				</el-select>
			</el-form-item> -->
			<!-- <el-form-item label="优惠规则类型" label-width="100">
				<el-select v-model="searchForm.userOriented" clearable placeholder="选择优惠规则类型" @clear="current = 1">
					<el-option label="所有用户" value="1"></el-option>
					<el-option label="新用户" value="2"></el-option>
				</el-select>
			</el-form-item> -->
			<!-- <el-form-item>
				<el-button @click="getCoupons" type="success">搜索</el-button>
			</el-form-item> -->
			<el-form-item>
				<el-button type="primary" @click="addUpdateCouponsButton(null)">
					添加优惠券
				</el-button>
			</el-form-item>
		</el-form>

		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column prop="waysObtain" align="center" label="优惠券" width="140">
				<template slot-scope="scope">
					<div v-if="scope.row.waysObtain == 1" type="success"> 单笔消费满多少送</div>
					<div v-else-if="scope.row.waysObtain == 2" type="success">新用户注册</div>
					<div v-else-if="scope.row.waysObtain == 3" type="success">活动赠送券</div>
				</template>
			</el-table-column>
			<el-table-column align="center" label="消费赠送条件(元)" prop="waysObtainMoney" width="160"></el-table-column>
			<el-table-column label="名称" align="center" prop="name"></el-table-column>
			<el-table-column prop="rulesType" align="center" label="优惠规则类型" width="120">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.type === 2" type="success"> 满减 </el-tag>
					<el-tag size="small" v-else-if="scope.row.type === 1" type="success"> 无门槛 </el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="validTime" align="center" width="120" label="有效时间(天)"></el-table-column>
			<el-table-column align="center" label="满减条件" prop="satisfyAmount" width="120"></el-table-column>
			<el-table-column align="center" label="优惠金额" prop="discountAmount" width="120"></el-table-column>
			<el-table-column prop="rulesType" align="center" label="状态" width="100">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.state === 0" type="info"> 禁用 </el-tag>
					<el-tag size="small" v-else-if="scope.row.state === 1" type="success"> 启用 </el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" align="center" width="200" label="创建时间"></el-table-column>
			<el-table-column prop="icon" align="center" width="360" fixed="right" label="操作">
				<template slot-scope="scope">
					<el-button type="primary" plain @click="dateCouponsButton(scope.row.id)"
						v-if="scope.row.state == 0">
						启用
					</el-button>
					<el-button type="danger" plain @click="dateCouponsButton(scope.row.id)" v-if="scope.row.state == 1">
						禁用
					</el-button>
					<template>
						<el-popconfirm title="确定删除该优惠券吗？" @confirm="delHandle(scope.row.id)">
							<el-button type="danger" plain slot="reference">删除</el-button>
						</el-popconfirm>
					</template>

					<el-button type="primary" plain v-if="scope.row.state == 1&&scope.row.waysObtain == 3"
						@click="sendall(scope.row)">赠送</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total"></el-pagination>
		<el-dialog title="确定给所有人发送此优惠券吗？一但发送无法撤回!" :visible.sync="showpons" width="70%" :before-close="handleClose">
			<el-form>
				<el-form-item label="赠送人数">
					<el-select v-model="type" clearable placeholder="赠送人数">
						<el-option label="赠送个人" value="2"></el-option>
						<el-option label="赠送所有人" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="赠送数量">
					<el-input type="number" style="width: 216px;" v-model="copnum" placeholder="请输入数量"
						clearable></el-input>
				</el-form-item>

			</el-form>
			<el-divider></el-divider>
			<div v-if="type==2">
				<el-form :inline="true">
					<el-form-item label="用户昵称" label-width="80px">
						<el-input v-model="name" placeholder="用户昵称" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="手机号" label-width="80px">
						<el-input v-model="phone" placeholder="手机号" clearable>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="getStoreGoods(1)" type="success">搜索</el-button>
					</el-form-item>
				</el-form>
				<el-table ref="multipleTable" :data="tableDatas" tooltip-effect="dark" style="width: 100%" border stripe
					@selection-change="handleSelectionChange">
					<el-table-column label="用户头像" align="center">
						<template slot-scope="scope"> <img width="50px" height="50px" :src="scope.row.avatarUrl"
								alt="" />
						</template>
					</el-table-column>
					<el-table-column label="用户昵称" align="center" prop="nickName"></el-table-column>
					<el-table-column label="用户手机号" align="center" prop="phone"></el-table-column>
					<el-table-column label="注册时间" align="center" prop="createTime"></el-table-column>
					<el-table-column label="操作" align="center" prop="icon" fixed="right">
						<template slot-scope="scope">

							<el-button type="danger" v-if="scope.row.userId == selectId" plain
								@click="selsctButton(scope.row.userId)">
								已选择
							</el-button>
							<el-button type="primary" v-else plain @click="selsctButton(scope.row.userId)">
								选择
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
					layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]"
					:current-page="currents" :page-size="sizes" :total="totals">
				</el-pagination>
			</div>
			<div style="height: 40px;"></div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showpons = false">取消</el-button>
				<el-button type="primary" @click="getfome()">确定</el-button>
			</span>
		</el-dialog>
		<AddUpdateCoupons ref="addUpdateCoupons" v-if="addUpdateCouponsvisible" @refreshDataList="getCoupons">
		</AddUpdateCoupons>
		<SelectUsers ref="getCouponsUsers" v-if="getCouponsUserssvisible"
			@refreshDataList="getUsersList(scope.row.couponsId)"></SelectUsers>
	</div>
</template>

<script>
	import AddUpdateCoupons from './AddUpdateCoupons'
import SelectUsers from './SelectUsers'
	export default {
		name: 'Coupons',
		components: {
			AddUpdateCoupons,
			SelectUsers,
		},
		data() {
			return {
				searchForm: {},
				delBtlStatu: true,
				tableData: [],
				tableDatas: [],
				multipleSelection: [],
				total: 0,
				size: 10,
				current: 1,
				totals: 0,
				sizes: 10,
				currents: 1,
				addUpdateCouponsvisible: false,
				getCouponsUserssvisible: false,
				showpons: false,
				copnum: 1,
				type: "2",
				id: '',
				template: '',
				phone: '',
				name: '',
				selectId: ''
			}
		},
		created() {
			this.getCoupons()
			this.getuser()
		},
		methods: {
			getStoreGoods(e) {
				this.currents = 1
				this.getuser();
			},
			selsctButton(e) {
				if (e == this.selectId) {
					this.selectId = ''
				} else {
					this.selectId = e
				}
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach((row) => {
						this.$refs.multipleTable.toggleRowSelection(row)
					})
				} else {
					this.$refs.multipleTable.clearSelection()
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				this.size = val
				this.getCoupons()
			},
			handleCurrentChange(val) {
				this.current = val
				this.getCoupons()
			},
			handleSizeChanges(val) {
				this.sizes = val
				this.getuser()
			},
			handleCurrentChanges(val) {
				this.currents = val
				this.getuser()
			},
			getuser() {
				this.$axios.post("/admin/userBase/getUserList", {
					pageNo: this.currents,
					pageSize: this.sizes,
					phone: this.phone,
					name: this.name
				}).then(res => {
					this.tableDatas = res.data.records
					this.sizes = res.data.size
					this.currents = res.data.current
					this.totals = res.data.total
				})
			},
			//获取资讯列表
			getCoupons() {
				var startTimes = ''
				var endTimes = ''
				if (this.searchForm.createTime != undefined) {
					startTimes = this.searchForm.createTime[0]
					endTimes = this.searchForm.createTime[1]
				}
				this.searchForm.startTimes = startTimes
				this.searchForm.endTimes = endTimes
				this.searchForm.pageNo = this.current
				this.searchForm.pageSize = this.size
				this.$axios
					.post('/admin/sysCouponSheet/getList', this.searchForm)
					.then((res) => {
						this.tableData = res.data.records
						this.size = res.data.size
						this.current = res.data.pages
						this.total = res.data.total
					})
			},
			//选择用户
			getUsersList(couponsId) {
				this.getCouponsUserssvisible = true
				this.$nextTick(() => {
					this.$refs.getCouponsUsers.init(couponsId)
				})
			},
			deCouponsButton(id) {

			},
			getfome() {
				if (this.type == 1) {
					this.$axios
						.post('/admin/sysCouponSheet/issueCoupon', {
							couponsId: this.id,
							number: this.copnum,
							type: this.type,
						})
						.then((res) => {
							this.getCoupons()
							this.showpons = false
							this.$message({
								showClose: true,
								message: '恭喜你，操作成功',
								type: 'success',
								onClose: () => {

								},
							})
						})
				} else {
					this.$axios
						.post('/admin/sysCouponSheet/issueCoupon', {
							couponsId: this.id,
							number: this.copnum,
							type: this.type,
							userId: this.selectId
						})
						.then((res) => {
							this.getCoupons()
							this.showpons = false
							this.$message({
								showClose: true,
								message: '恭喜你，操作成功',
								type: 'success',
								onClose: () => {

								},
							})
						})
				}

			},
			sendall(e) {
				this.id = e.id
				this.showpons = true


			},
			handleClose() {
				this.showpons = false
			},
			dateCouponsButton(id) {
				this.$axios
					.post('/admin/sysCouponSheet/updateState', {
						id: id
					})
					.then((res) => {
						this.getCoupons()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
			},
			//删除资讯
			delHandle(id) {
				this.$axios
					.post('/admin/sysCouponSheet/del', {
						id: id
					})
					.then((res) => {
						this.getCoupons()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
			},

			//下架、上架商城商品
			updCouponsIsOnframe(model) {
				this.$confirm(
					'操作需谨慎：此操作将是该优惠券' +
					(model.isOnframe === 0 ? '下架' : '上架') +
					'，是否继续?',
					'提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					},
				).then(() => {
					this.$axios
						.post('/admin/coupons/updCouponsIsOnframe', {
							couponsId: model.couponsId,
						})
						.then((res) => {
							this.$message({
								showClose: true,
								message: res.msg,
								type: 'success',
								onClose: () => {
									this.getCoupons()
								},
							})
						})
				})
			},

			addUpdateCouponsButton(id) {
				this.addUpdateCouponsvisible = true
				this.$nextTick(() => {
					this.$refs.addUpdateCoupons.init(id)
				})
			},
		},
	}
</script>

<style scoped>
	.el-button {
		padding: 0 10px;
		height: 35px;
		line-height: 35px;
		font-size: 15px;
		margin-right: 10px;
	}
</style>